// As Etapas do processamento interno. Na Fase 1 servem só de âncora para o
// Tempo de Referência; o acompanhamento por Etapas (Kanban) é Fase 2, e as
// colunas serão derivadas dos Processos dos Tipos de Peça (ADR-0006), não de
// uma rota de Categoria.

export const ETAPAS = [
  "lavando",
  "secando",
  "passando",
  "dobra",
  "pronto",
] as const;
export type Etapa = (typeof ETAPAS)[number];

const ROTULO: Record<Etapa, string> = {
  lavando: "Lavando",
  secando: "Secando",
  passando: "Passando",
  dobra: "Dobra",
  pronto: "Pronto",
};

export function rotuloEtapa(e: Etapa): string {
  return ROTULO[e];
}
